import { carPath } from './listingUrl';
import { trackDiscovery } from '../services/discovery.service';
import { showAppAlert } from './appAlert';

export const buildCarShareUrl = (carId, carName) => `${window.location.origin}${carPath(carId,carName)}`;

export const shareCar = async ({ carId, carName }) => {
  const shareUrl = buildCarShareUrl(carId,carName);
  trackDiscovery('share',carId);
  const shareTitle = carName || 'Go Rides vehicle';

  try {
    if (navigator.share) {
      await navigator.share({
        title: shareTitle,
        text: `Check out this vehicle on Go Rides: ${shareTitle}`,
        url: shareUrl
      });
      return;
    }

    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(shareUrl);
      showAppAlert({
        type: 'success',
        title: 'Link copied',
        message: 'The car link has been copied to your clipboard.'
      });
      return;
    }

    showAppAlert({
      type: 'info',
      title: 'Share link',
      message: shareUrl
    });
  } catch (error) {
    if (error?.name === 'AbortError') {
      return;
    }

    showAppAlert({
      type: 'error',
      title: 'Share failed',
      message: 'We could not share this car right now.'
    });
  }
};
